<script setup lang="ts">
import { defineSlots, computed } from 'vue';

const slots = defineSlots<{
  start?: () => any;
  middle?: () => any;
  end?: () => any;
}>();

// ===================================================================
// Computed
// ===================================================================
// Compute how many slots are provided to determine layout
const activeSlots = computed(() => {
  return {
    start: !!slots.start,
    middle: !!slots.middle,
    end: !!slots.end
  };
});

// ===================================================================
// Getters
// ===================================================================
// Compute the width class based on number of active slots
const getWidthClass = computed(() => {
  const count = Object.values(activeSlots.value).filter(Boolean).length;

  switch (count) {
    case 1: return 'w-full';
    case 2: return 'w-1/2';
    default: return 'w-1/3';
  }
});
</script>

<template>
  <div class="flex w-full fixed bottom-[1.5em] left-0 justify-between items-center">
    <div v-if="slots.start" :class="[getWidthClass, 'py-2 bg-secondary text-white font-medium transition-colors hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange-500']">
      <slot name="start" />
    </div>
    <div v-if="slots.middle" :class="[getWidthClass, 'py-2 bg-primary text-white font-medium transition-colors hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500']">
      <slot name="middle" />
    </div>
    <div v-if="slots.end" :class="[getWidthClass, 'py-2 bg-green-600 text-white font-medium transition-colors hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500']">
      <slot name="end" />
    </div>
  </div>
</template>